<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import ObjectOfExpenditures from "@/components/tables/objectOfExpenditures.vue";
import PrexcTransactions from "@/components/tables/prexctransactions";
import PrintOptions from "@/components/modals/print-options";
import Treeselect from "@riophae/vue-treeselect";
import {map, uniqueId} from "lodash";

export default {
    page: {
        title: "Object Expenditures",
    },
    components: {
        Layout,
        PageHeader,
        LoadingTemplate,
        ObjectOfExpenditures,
        PrexcTransactions,
        PrintOptions,
        Treeselect
    },
    data() {
        return {
            title: "Object Expenditures",
            items: [
                {
                text: "Dashboards",
                href: "/",
                },
                {
                text: "Object Expenditures",
                active: true,
                },
            ],
            sideBar: false,
            fundSources: [],
            filterFS: "",
            fundSourceLoading: false,
            selectedFS: null,
            expenditures: [],
            oeTableBusy: false,
            transactionModal: false,
            transactionBusy: false,
            fundSourceBalance: 0,
            OETransactions: [],
            objectExpenditure: null,
            newAccounts: [],
            availableAccounts: [],
            accountLoading: false,
        };
    },
    async mounted() {
        this.sideBar = true;
        this.fundSourceLoading = true;
        await this.wait(500)
        this.$refs.filterFS.focus();
        await this.getFundSources(this.$store.state.data.selectedCampus.id);
        this.fundSourceLoading = false;
    },
    methods: {
        async changeCycle(cycle){
            this.sideBar = true;
            this.selectedFS = null;
            this.fundSourceLoading = true;
            await this.wait(500)
            this.$refs.filterFS.focus();
            await this.getFundSources(this.$store.state.data.selectedCampus.id);
            this.fundSourceLoading = false;
        },
        async changeCampus(campus){
            this.sideBar = true;
            this.selectedFS = null;
            this.fundSourceLoading = true;
            await this.wait(500)
            this.$refs.filterFS.focus();
            await this.getFundSources(campus.id);
            this.fundSourceLoading = false;
        },
        async getFundSources(id) {
            await this.$store
                .dispatch("fundsource/GetActiveFundSourcesByCampusId", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data;
                })
                .catch((err) => {
                    this.showToast("Failed to fetch fund sources. Please contact administrator", "error");
                });
        },
        async selectFS(item) {
            if(!item.length) return;
            this.selectedFS = item[0];
            this.sideBar = false;
            this.oeTableBusy = true;
            await this.getOEs(this.selectedFS.id);
            this.oeTableBusy = false;
        },
        async getOEs(id){
            await this.$store
                .dispatch("objectOfExpenditures/getObjectOfExpendituresByFSAndCycle", {
                    cycle: this.$store.state.data.cycle,
                    fundSourceId: id,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.expenditures = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong. Cannot fetch Object of Expenditures","danger");
                });
        },
        deleteItem(props){
            this.$swal({
                title: "Are you sure?",
                text:
                "Are you sure you want to remove this Object of Expenditure? You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("objectOfExpenditures/removeObjectOfExpenditures", props.item.id)
                        .then(async (res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.expenditures.findIndex((item) => item.id == props.item.id);
                            this.expenditures.splice(index, 1);
                            this.showToast("Successfully deleted object of expenditure", "success");
                        })
                        .catch(() => {
                        this.showToast(
                            "Something went wrong. Unable to delete object of expenditure",
                            "error"
                        );
                        });
                }
            });
        },
        print(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "/api/Report/Finance/RAOS",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async changeFS(){
            this.sideBar = true;
            await this.wait(500)
            this.$refs.filterFS.focus();
        },
        async viewTransactions(item) {
            this.transactionModal = true;
            this.transactionBusy = true;
            this.fundSourceBalance = this.selectedFS.balance;
            await this.wait(1000);
            this.getObjectOfExpenditure(item.item.id);
            this.transactionBusy = true;
            await this.getOETransactions(item.item.id);
            this.transactionBusy = false;
        },
        async getObjectOfExpenditure(id) {
            await this.$store
                .dispatch("objectOfExpenditures/getSingleObjectOfExpenditures", id)
                .then((response) => {
                    this.objectExpenditure = response.data;
                })
                .catch(() => {
                    this.showToast("Unable to fetch Object of Expenditure details", "error");
                });
        },
        async getOETransactions(id) {
            await this.$store
                .dispatch("objectOfExpenditures/getObjectOfExpenditureTransactionByExpenditureId",
                id
                )
                .then((response) => {
                    this.OETransactions = response.data;
                    this.transactionBusy = false;
                })
                .catch(() => {
                    this.showToast("Unable to fetch Object of Expenditure transactions", "error");
                });
        },
        updateFundSourceBalance(object) {
            this.fundSourceBalance = object.newBalance;
            this.selectedFS.balance = object.newBalance;
            // this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome).prexcs
            //     .find((item) => item.id === object.prexcId).expenditures
            //     .find((obj) => obj.id === object.id).objectOfExpenditureTransactions = object.transactions;
            // if (object.type === "transfer") {
            //     this.outcomes.find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId)
            //     .expenditures.find(
            //         (obj) => obj.id === object.id
            //     ).objectOfExpenditureTransactions = object.transactions;
            //     this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId)
            //     .expenditures.find((obj) => obj.id === object.id).balance += object.amount;

            //     this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId)
            //     .expenditures.find((obj) => obj.id === object.id).allocation += object.amount;
            // }
            // if (object.type === "revert") {
            //     this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId)
            //     .expenditures.find((obj) => obj.id === object.id).balance -= object.amount;
            // }
            // const bal = sumBy(
            //     this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId).expenditures,
            //     "balance"
            // );
            // const allocation = sumBy(
            //     this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId).expenditures,
            //     "allocation"
            // );
            // this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId).balance = bal;
            // this.outcomes
            //     .find((outcome) => outcome.id === this.selectedOutcome)
            //     .prexcs.find((item) => item.id === object.prexcId).allocated = allocation;
        },
        formatCurrency(data) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "PHP",
            }).format(data);
        },
        async addNewItem(){
            this.accountLoading = true;
            await this.getAvailableAccounts(this.selectedFS.id);
            this.accountLoading = false;
            this.$bvModal.show("expenditures-modal");
        },
        getAvailableAccounts(id){
            this.$store
                .dispatch("objectOfExpenditures/getAvailableAccount", {
                    cycle: this.$store.state.data.cycle,
                    fundSourceId: id,
                })
                .then((res) => {
                    console.log(res.data)
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.availableAccounts = map(res.data, (item) => ({
                        id: uniqueId("fc_"),
                        label: item.fundClassification.classification,
                        children: item.accountGroups.map((group) => ({
                            id: group.id,
                            label: `${group.groupName}`
                        })),
                    }));
                    this.accountLoading = false;
                })
                .catch((e) => {
                    console.log(e)
                    this.showToast("Something went wrong. Cannot fetch available accounts", "error");
                });
        },
        saveAccounts() {
            const data = this.newAccounts.map((item) => ({
                fundSourceId: this.selectedFS.id,
                accountGroupId: item,
                cycle: this.$store.state.data.cycle,
            }));
            this.$store
                .dispatch("objectOfExpenditures/createObjectOfExpenditures", data)
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.$bvModal.hide("expenditures-modal");
                    this.accountLoading = true;
                    await this.getOEs(this.selectedFS.id);
                    this.accountLoading = false;
                    this.showToast("Successfully added new object of expenditures", "success");
                })
                .catch((eror) => {
                    this.showToast(
                        "Something went wrong. Creating accounts failed. Please contact your administrator",
                        "error"
                    );
                });
        },
    }

};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
        <PageHeader :title="title" :items="items" />
        <hr>
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <b-button @click="changeFS" variant="primary" v-if="!selectedFS">
                    <i class="bx bx-search-alt align-middle me-2"></i> View Fund Sources
                </b-button>
                <div v-else class="cursor-pointer"  @click="changeFS">
                    <h3 class="m-0 cursor-pointer text-green" style="line-height:1;">{{selectedFS.sourceName}}</h3>
                    <small><a href="javascript:void(0);" class="text-white">[Click here to change fund source ]</a></small>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <small class="d-block">Unallocated Budget: </small>
                <h4 class="mb-0 text-yellow">
                {{ selectedFS ? formatCurrency(selectedFS.balance) : formatCurrency(0)}}
                </h4>
            </div>
        </div>
        <hr>
        <div class="mt-2">
            <ObjectOfExpenditures 
                :objectOfExpenditures="expenditures"
                :oeTableBusy="oeTableBusy"
                :selectedFS="selectedFS"
                @add-new="addNewItem"
                @viewTransactions="viewTransactions"
                @deleteItem="deleteItem"
                @print="print" 
            />
        </div>
        <b-modal 
            v-model="transactionModal"
            size="xl"
            title="Object of Expenditure Transactions"
            no-close-on-backdrop
            hide-footer
            no-fade
        >
            <template  v-if="transactionBusy">
                <LoadingTemplate />
            </template>
            <PrexcTransactions 
                v-else
                :transactionTable="OETransactions"
                :obj="objectExpenditure"
                :transactionBusy="transactionBusy"
                :fundSourceBalance="fundSourceBalance"
                @updatedFS="updateFundSourceBalance" 
            />
        </b-modal>
        <b-modal 
            id="expenditures-modal"
            size="lg"
            title="Select accounts"
            no-close-on-backdrop
            no-fade
        >
            <div v-if="accountLoading">
                <b-spinner small></b-spinner>
                <span class="ms-2">Loading...</span>
            </div>
            <div class="row" v-else>
                <treeselect 
                    :multiple="true"
                    :options="availableAccounts"
                    :clearOnSelect="true"
                    value-consists-of="LEAF_PRIORITY"
                    :disable-branch-nodes="true"
                    :limit="5"
                    :max-height="300"
                    v-model="newAccounts" 
                />
            </div>
            <template #modal-footer>
                <b-button variant="primary" @click="saveAccounts"> Save </b-button>
                <b-button variant="link" @click="$bvModal.hide('expenditures-modal')"> Close </b-button>
            </template>
        </b-modal>
        <b-sidebar
            v-model="sideBar"
            id="sidebar-1"
            width="40em"
            title="Fund Source"
            bg-variant="dark"
            text-variant="light"
            shadow
            no-header
            backdrop
        >
            <template>
                <div class="p-3">
                    <h4 class="mb-3 font-size-17">Fund Sources</h4>
                    <hr />
                    <div class="row mb-3">
                        <div class="col-md-6 text-md-start">
                        <b-form-input
                            v-model="filterFS"
                            type="search"
                            placeholder="Search fund source..."
                            ref="filterFS"
                        ></b-form-input>
                        </div>
                    </div>
                    <div class="table-responsive mb-0 mt-3">
                        <b-table
                            :items="fundSources"
                            :fields="[{key: 'sourceName', sortable: true, label: 'Fund Source Name'}]"
                            responsive="sm"
                            :filter="filterFS"
                            :filter-included-fields="[ 'sourceName', 'shortName']"
                            :busy="fundSourceLoading"
                            bordered
                            outlined
                            hover
                            striped
                            show-empty
                            select-mode="single"
                            selectable
                            @row-selected="selectFS"
                            selected-variant="dark"
                        >
                            <template #table-busy>
                                <LoadingTemplate />
                            </template>
                            <template #empty="scope">
                                <div class="text-center">{{ scope.emptyText }}</div>
                            </template>
                            <template #cell(sourceName)="row">
                                <div style="line-height:1;">
                                    <strong><span class="text-white font-size-16">{{row.value}}</span></strong> <sup class="text-green">({{row.item.shortName}})</sup>
                                </div>
                                <small>{{row.item.fundsAvailableSignatory ? `${row.item.fundsAvailableSignatory} (${row.item.fundsAvailableSignatoryPosition})` : 'No signatory' }} </small>
                            </template>
                        </b-table>
                    </div>
                </div>
            </template>
        </b-sidebar>
        <print-options ref="printOpt"></print-options>
    </Layout>
</template>
<style>
.b-sidebar > .b-sidebar-body {
  overflow-x: hidden;
}
</style>